import theme from 'theme'

export default function GlyphSubIcon(props) {
  return (
    <div
      css={{
        position: 'absolute',
        display: 'flex',
        bottom: -theme.space[2],
        right: -theme.space[2],
        fontSize: theme.fontSizes[0],
        width: theme.space[4],
        height: theme.space[4],
        alignItems: 'center',
        padding: theme.space[1],
        border: `3px solid ${theme.colors.white[0]}`,
        color: theme.colors.white[0],
        fontWeight: theme.fontWeights[1],
        borderRadius: 20
      }}
      {...props}
    />
  )
}
